.VerifiedIcon {
  line-height: 0;
  display: inline-block;
  vertical-align: middle;

  .verifiedUser {
    position: relative;

    path {
      fill: var(--primitives-colors-brand-secondary);
      background: var(--semantic-colors-typography-inverse);
    }

    rect {
      fill: var(--semantic-colors-typography-inverse);
    }
  }
}
